import React from 'react';

const Footer = ({ variant = 'default' }) => {
  // Default footer (ProductDetails style)
  if (variant === 'default') {
    return (
      <footer className="bg-zinc-100 dark:bg-zinc-900 w-full border-t border-zinc-200 text-sm leading-relaxed">
        <div className="flex flex-col md:flex-row justify-between items-center px-12 py-16 w-full max-w-screen-2xl mx-auto">
          <div className="mb-8 md:mb-0 space-y-4">
            <img
              src="/assets/elite-goats.png"
              alt="Elite Goats & Sheeps Hub"
              className="h-16 w-auto object-contain"
            />
            <p className="text-zinc-500 max-w-xs">
              Connecting elite breeders with discerning buyers through a modern pastoral digital experience.
            </p>
          </div>
          <div className="flex flex-wrap justify-center gap-8 text-zinc-600 font-medium">
            <a href="#" className="hover:text-primary transition-all">
              Terms of Sale
            </a>
            <a href="#" className="hover:text-primary transition-all">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-primary transition-all">
              Shipping & Logistics
            </a>
            <a href="#" className="hover:text-primary transition-all">
              Contact Support
            </a>
          </div>
        </div>
        <div className="px-12 pb-12 w-full flex flex-col md:flex-row justify-between items-center text-zinc-400 border-t border-zinc-200/50 pt-8 max-w-screen-2xl mx-auto">
          <p>© {new Date().getFullYear()} All rights reserved by elitegoatsandsheeps powered by Mimamsa</p>
        </div>
      </footer>
    );
  }

  // Premium footer (BreederProfile style)
  if (variant === 'premium') {
    return (
      <footer className="bg-slate-900 text-white py-24 px-6 lg:px-12">
        <div className="max-w-screen-2xl mx-auto flex flex-col md:flex-row justify-between items-start gap-16">
          <div className="space-y-8 max-w-sm">
            <img
              alt="Logo"
              className="h-16 w-auto brightness-0 invert"
              src="/assets/ELITE GOATS.png"
            />
            <p className="text-slate-400 font-light leading-relaxed">
              Elite Goats & Sheeps Hub is the world's premier digital marketplace for institutional and private livestock collectors.
            </p>
            <div className="flex gap-4">
              <a
                className="w-10 h-10 rounded-full border border-slate-800 flex items-center justify-center hover:bg-primary transition-all"
                href="#"
              >
                <span className="material-symbols-outlined text-lg">public</span>
              </a>
              <a
                className="w-10 h-10 rounded-full border border-slate-800 flex items-center justify-center hover:bg-primary transition-all"
                href="#"
              >
                <span className="material-symbols-outlined text-lg">mail</span>
              </a>
              <a
                className="w-10 h-10 rounded-full border border-slate-800 flex items-center justify-center hover:bg-primary transition-all"
                href="#"
              >
                <span className="material-symbols-outlined text-lg">share</span>
              </a>
            </div>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-16">
            <div className="space-y-6">
              <h5 className="text-xs font-bold uppercase tracking-[0.3em] text-primary">Platform</h5>
              <ul className="space-y-4 text-sm text-slate-400">
                <li>
                  <a className="hover:text-white transition-all" href="#">
                    Marketplace
                  </a>
                </li>
                <li>
                  <a className="hover:text-white transition-all" href="#">
                    Live Auctions
                  </a>
                </li>
                <li>
                  <a className="hover:text-white transition-all" href="#">
                    Verification Process
                  </a>
                </li>
              </ul>
            </div>
            <div className="space-y-6">
              <h5 className="text-xs font-bold uppercase tracking-[0.3em] text-primary">Support</h5>
              <ul className="space-y-4 text-sm text-slate-400">
                <li>
                  <a className="hover:text-white transition-all" href="#">
                    Logistics & Shipping
                  </a>
                </li>
                <li>
                  <a className="hover:text-white transition-all" href="#">
                    Health Protocols
                  </a>
                </li>
                <li>
                  <a className="hover:text-white transition-all" href="#">
                    Privacy Policy
                  </a>
                </li>
              </ul>
            </div>
            <div className="space-y-6 col-span-2 sm:col-span-1">
              <h5 className="text-xs font-bold uppercase tracking-[0.3em] text-primary">Currency</h5>
              <p className="text-sm text-slate-400">
                Trading in <span className="text-white font-bold">INR (₹)</span> • Global Wire Transfer Supported.
              </p>
            </div>
          </div>
        </div>
        <div className="max-w-screen-2xl mx-auto pt-16 mt-16 border-t border-slate-800 flex flex-col md:flex-row justify-between items-center gap-6 text-xs text-slate-500 font-bold uppercase tracking-widest">
          <p>© {new Date().getFullYear()} All rights reserved by elitegoatsandsheeps powered by Mimamsa</p>
          <div className="flex gap-8">
            <a className="hover:text-white transition-all" href="#">
              Terms
            </a>
            <a className="hover:text-white transition-all" href="#">
              GDPR
            </a>
            <a className="hover:text-white transition-all" href="#">
              Cookie Settings
            </a>
          </div>
        </div>
      </footer>
    );
  }
};

export default Footer;
